import Lottie from "lottie-react";
import { isMobile } from "react-device-detect";
import successAnimation from "../assets/animation/success_animation.json";
import successAnimationMobile from "../assets/animation/success_animation_mobile.json";

const CongratsAnimation: React.FC = () => {
  return (
    <div className={`congrats-animation animation`}>
      <Lottie
        className="animation"
        animationData={isMobile ? successAnimationMobile : successAnimation}
        loop={true}
        autoPlay={true}
      />
    </div>
  );
};

export default CongratsAnimation;
